// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3adWK","col":"Table_col__2vj1_","fulfillmentStatus":"Table_fulfillmentStatus__PXhao","emailCol":"Table_emailCol__gjyCE"};